import styles from "./Peers.module.scss";
import { FC, lazy, Suspense } from "react";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { Box, CircularProgress, Typography } from "@mui/material";
const MUILineChart = lazy(() => import("@/components/line-chart/MUILineChart"));

interface PropsTypes {
    row?: any;
    ts: number[];
    valueCss?: string;
    month: number;
    mobile?: boolean;
    overviewPage?: boolean;
    obfuscated?: boolean;
}

const Peers: FC<PropsTypes> = ({ row, ts, valueCss, month, mobile, overviewPage, obfuscated = false }) => {
    return overviewPage ? (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Typography sx={{ height: "40%" }} variant={mobile ? "h2" : "moduleContentTitle"} component={mobile ? "div" : "span"} className={valueCss ? valueCss : ""}>
                <Box sx={{ lineHeight: 1 }}>
                    <Typography variant="subtitle2" component="div" style={{ color: "var(--text-3, #8a8f97)", textTransform: "initial" }}>
                        1m vs peers
                    </Typography>
                </Box>
                {Number(month).toFixed(2)}%
            </Typography>

            <Box sx={{ height: "60%" }}>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={ts} id={row && row.stock.ticker + row.peer_cor.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </Box>
        </Box>
    ) : (
        <div className={styles.Peers}>
            <Typography variant={mobile ? "h2" : "moduleContentTitle"} component={mobile ? "div" : "span"} className={valueCss ? valueCss : ""}>
                <Box sx={{ lineHeight: 1 }}>
                    <Typography variant="subtitle2" component="div" style={{ color: "var(--text-3, #8a8f97)", textTransform: "initial" }}>
                        1m vs peers
                    </Typography>
                </Box>
                {Number(month).toFixed(2)}%
            </Typography>
            <div className={styles.chart}>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={ts} id={row && row.stock.ticker + row.peer_cor.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </div>
        </div>
    );
};

export default withStockStamp(Peers, "month", { title: "Peers" });
